import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import { http } from "../../helper";
import { BaseUrl } from "../../common/config";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { canAction } from "../../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_promooffers";

const EditSectorPromoOffers = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [cartAmountFrom, setCartAmountFrom] = useState(0);
  const [cartAmountTo, setCartAmountTo] = useState(0);
  const [cartAmountTarget, setCartAmountTarget] = useState(0);
  const [freeProductsCount, setFreeProductsCount] = useState(1);
  const [errormsg, setErrormsg] = useState({});
  const [freeloading, setfreeLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [freeproducts, setfreeProducts] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessage1, setAlertMessage1] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const [status, setStatus] = useState("active");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedFreeCategories, setSelectedFreeCategories] = useState([]);
  const [checkedval, setCheckedval] = useState([]);
  const [checkedfreeval, setCheckedfreeval] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [checkedfreeState, setCheckedfreeState] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [errmessage, setErrMessage] = useState({});
  const [priceBandIds, setPriceBandIds] = useState([]);
  const [checkedBandState, setCheckedBandState] = useState([]);
  const [checkedBand, setCheckedBand] = useState([]);
  const [alertSector, setAlertSector] = useState("");
  const [sectorOptions, setSectorOptions] = useState([]);
  const [isSectorLoading, setIsSectorLoading] = useState(false);
  const [initialSector, setInitialSector] = useState("");
  const [beforeTooltipMessage, setBeforeTooltipMessage] = useState("");
  const [afterTooltipMessage, setAfterTooltipMessage] = useState("");
  const [flexTitle, setFlexTitle] = useState("");
  const [isSuccessPopup, setIsSuccessPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const params = useParams();

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promooffers")
  ) {
    window.location.href = "/unauthorized";
  }

  function cancelbtn(e) {
    e.preventDefault();
    window.location.href = "/promooffers?tab=sector";
    return false;
  }

  useEffect(() => {
    setCheckedState(new Array(products.length).fill(false));
    setCheckedval([]);
  }, [products]);

  useEffect(() => {
    const filteredFreeProducts = getFilteredFreeProducts();
    const arry = filteredFreeProducts.map((prd) => {
      // Check if the productNumber is included in the checkedval array
      if (prd.PDP_Status === "deactivate") {
        return false;
      }
      return checkedfreeval.includes(prd.productNumber);
    });
    setCheckedfreeState(arry);
  }, [freeproducts, checkedfreeval, selectedFreeCategories]);

  useEffect(() => {
    const arry = priceBandIds.map((band) => {
      return checkedBand.includes(band.accountPriceListId) ? true : false;
    });
    setCheckedBandState(arry);
  }, [priceBandIds, checkedBand]);

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setIsLoading(true);
    let URL1 = BaseUrl + `admin/editsectorpromooffers/${params.id}`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data[0];
        setLoading(false);
        setAlertSector(responseData.sectorName);
        setInitialSector(responseData.sectorName);
        setFromDate(
          responseData.FromDate
            ? moment(responseData.FromDate, "YYYY-MM-DD").toDate()
            : "",
        );
        setToDate(
          responseData.ToDate
            ? moment(responseData.ToDate, "YYYY-MM-DD").toDate()
            : "",
        );
        setCartAmountTarget(responseData.cartAmountTarget);
        setSortOrder(responseData.sortOrder);
        setStatus(responseData.Status);
        setAlertMessage(responseData.message);
        setAlertMessage1(responseData.message1);
        setFreeProductsCount(responseData.freeProductQtyToAdd);
        setCheckedfreeval(responseData.freeProductToAdd.split(","));
        setCheckedBand(responseData.PriceBandTobeExcluded.split(","));
        setBeforeTooltipMessage(responseData.beforeTooltipMessage || "");
        setAfterTooltipMessage(responseData.afterTooltipMessage || "");
        setFlexTitle(responseData.flexTitle || "");
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    var priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setProducts(responseData);
        setfreeProducts(responseData);
      })
      .catch((err) => {
        console.log(err);
        setLoading(true);
      });

    let URL2 = `${BaseUrl}admin/getpricebandids`;
    http
      .get(URL2)
      .then((response) => {
        let responseData = response?.data?.data;
        // Filter out duplicate price band IDs
        // Convert to a Set to remove duplicates
        // and then convert back to an array
        const uniquePriceBandIds = responseData.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.accountPriceListId === item.accountPriceListId,
            ),
        );
        setPriceBandIds(uniquePriceBandIds);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(true);
      });
  }, []);
  // Map of category names to category IDs
  const categoryMap = {
    pizza: ["1"],
        pasta: ["10", "13", "11", "12"],
        desserts: ["14"]
    };

  const handleOnChange1 = (position, e) => {
    const updatedfreeCheckedState = checkedfreeState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedfreeval];
    if (e.target.checked) {
      updatedList = [...checkedfreeval, e.target.value];
    } else {
      updatedList.splice(checkedfreeval.indexOf(e.target.value), 1);
    }
    setCheckedfreeval(updatedList);
    setErrormsg((prev) => ({
      ...prev,
      checkedfreevalErr: updatedList.length > 0 ? "" : t("field_required_txt"),
    }));
    setCheckedfreeState(updatedfreeCheckedState);
  };

  const freeCountChange = (e) => {
    setFreeProductsCount(e.target.value);
    setErrormsg((prev) => ({ ...prev, freeProductsCountErr: "" }));
  };

  const handleOnChangeBand = (position, e) => {
    const updatedCheckedState = checkedBandState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedBand];
    if (e.target.checked) {
      updatedList = [...checkedBand, e.target.value];
    } else {
      updatedList.splice(checkedBand.indexOf(e.target.value), 1);
    }
    setCheckedBand(updatedList);
    setCheckedBandState(updatedCheckedState);
  };

  const message1HandleChange = (e) => {
    setAlertMessage1(e.target.value);
    const value = e.target.value || "";
    setErrormsg((prev) => ({
      ...prev,
      message1Err: value.trim() ? "" : prev.message1Err,
    }));
  };

  const messageHandleChange = (e) => {
    setAlertMessage(e.target.value);
    const value = e.target.value || "";
    setErrormsg((prev) => ({
      ...prev,
      messageErr: value.trim() ? "" : prev.messageErr,
    }));
  };

  const targetAmountHandleChange = (e) => {
    const value = e.target.value;
    setCartAmountTarget(value === "" ? "" : Number(value));
    setErrormsg((prev) => ({
      ...prev,
      cartAmountTargetErr: value.trim() ? "" : prev.cartAmountTargetErr,
    }));
  };

  const handleInputChange = (setter, errorKey) => (e) => {
    const value = e.target.value;
    setter(value);
    setErrormsg((prev) => ({
      ...prev,
      [errorKey]: value.trim() ? "" : prev[errorKey],
    }));
  };

  const formvalidation = () => {
    let newErrors = {};
    let isValid = true;
    if (!cartAmountTarget) {
      newErrors.cartAmountTargetErr = t("field_required_txt");
      isValid = false;
    }
    if (!alertMessage) {
      newErrors.messageErr = t("field_required_txt");
      isValid = false;
    }
    if (!alertMessage1) {
      newErrors.message1Err = t("field_required_txt");
      isValid = false;
    }
    if (!toDate) {
    } else if (toDate < fromDate) {
      newErrors.toDateErr = t("todate_err_txt");
      isValid = false;
    }
    // Filter checkedfreeval to only include active products
    const activeCheckedFreeVal = checkedfreeval.filter((productNumber) =>
      freeproducts.some(
        (prd) =>
          prd.productNumber === productNumber &&
          prd.PDP_Status !== "deactivate",
      ),
    );
    if (!activeCheckedFreeVal.length) {
      newErrors.checkedfreevalErr = t("field_required_txt");
      isValid = false;
    }
    if (!beforeTooltipMessage) {
      newErrors.beforeTooltipMessageErr = t("field_required_txt");
      isValid = false;
    }
    if (!afterTooltipMessage) {
      newErrors.afterTooltipMessageErr = t("field_required_txt");
      isValid = false;
    }
    if (!flexTitle) {
      newErrors.flexTitleErr = t("field_required_txt");
      isValid = false;
    }
    setErrormsg(newErrors);
    return isValid;
  };

  const submitButton = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    const selectedSector = sectorOptions.find(
      (s) => String(s.value) === String(alertSector),
    );
    const isValid = formvalidation();
    // Filter out deactivated products before count check
    const activeCheckedProducts = checkedfreeval.filter((productNumber) =>
      freeproducts.some(
        (prd) =>
          prd.productNumber === productNumber &&
          prd.PDP_Status !== "deactivate",
      ),
    );
    if (activeCheckedProducts.length > freeProductsCount) {
      setAlertPopup(true);
      setIsSuccessPopup(false);
      setPopupMessage(
        t("selected_products_limit_exceeded_txt", {
            selected: checkedfreeval.length,
            allowed: freeProductsCount,
        }),
      );
      return;
    }
    if (isValid) {
      // Filter out deactivated free products
      const activeFreeProducts = freeproducts.filter(
        (prd) => prd.PDP_Status !== "deactivate",
      );
      const filteredCheckedFreeVal = checkedfreeval.filter((productNumber) =>
        activeFreeProducts.some((prd) => prd.productNumber === productNumber),
      );
      let payload = {
        sectorName: alertSector || "",
        cartAmountTarget: cartAmountTarget,
        FromDate: fromDate,
        ToDate: toDate,
        sortOrder: sortOrder,
        freeProductToAdd: filteredCheckedFreeVal.toString(),
        freeProductQtyToAdd: freeProductsCount,
        Status: status,
        createdBy: JSON.parse(sessionStorage.getItem("authData")).adminName,
        message: alertMessage,
        message1: alertMessage1,
        pid: params.id,
        PriceBandTobeExcluded: checkedBand.toString(),
        beforeTooltipMessage: beforeTooltipMessage,
        afterTooltipMessage: afterTooltipMessage,
        flexTitle: flexTitle,
      };
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + "admin/editsectorpromooffers";
      http
        .put(URL, payload)
        .then((response) => {
          if (response.data.success === true) {
            const sectorName =
              sectorOptions.find((s) => String(s.value) === String(alertSector))
                ?.name || alertSector;
            setAlertPopup(true);
            setIsSuccessPopup(true);
            setPopupMessage(
                t("sector_promo_offer_updated_successfully_txt", {
                    sector: sectorName,
                }),
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleFreeCategoryChange = (e) => {
    const { name, checked } = e.target;
    setSelectedFreeCategories((prevSelectedFreeCategories) => {
      if (checked) {
        // Add the category if it's checked
        return [...prevSelectedFreeCategories, name];
      } else {
        // Remove the category if it's unchecked
        return prevSelectedFreeCategories.filter((cat) => cat !== name);
      }
    });
  };

  const handleclick = () => {
    setExpanded(!expanded);
    setfreeLoading(false);
  };

  const getFilteredFreeProducts = () => {
    const selectedFreeCategoryIds = selectedFreeCategories
      .map((category) => categoryMap[category])
      .flat(); // Flatten the array to merge all IDs into one array
    // Filter products based on the selected category IDs
    return freeproducts.filter((prd) =>
      selectedFreeCategoryIds.includes(prd.categoryId),
    );
  };

  const filteredFreeProducts = getFilteredFreeProducts();

  const fetchSectors = async () => {
    try {
      setIsSectorLoading(true);
      // 1. Get all sectors
      const sectorRes = await http.get(
        `${BaseUrl}admin/product/masterentries/sectors`,
      );
      // 2. Get already added sector promos
      const promoRes = await http.get(`${BaseUrl}admin/listsectorpromooffers`);
      if (sectorRes.data?.success && promoRes.data?.data) {
        const allSectors = sectorRes.data.data;
        const usedSectors = promoRes.data.data;
        // Get used sector names
        const usedSectorNames = usedSectors.map((item) => item.sectorName);
        // FILTER LOGIC
        const filtered = allSectors.filter(
          (item) =>
            !usedSectorNames.includes(item.MasterValue) ||
            item.MasterValue === initialSector,
        );
        // Format
        const formatted = filtered.map((item) => ({
          name: item.MasterValue,
          value: item.MasterId,
        }));
        setSectorOptions(formatted);
      }
    } catch (err) {
      console.error("Failed to fetch sectors", err);
    } finally {
      setIsSectorLoading(false);
    }
  };

  useEffect(() => {
    if (initialSector !== "") {
      fetchSectors();
    }
  }, [initialSector]);

  const eventSectorHandleChange = (e) => {
    const value = e.target.value || "";
    setAlertSector(value);
    setErrormsg((prev) => ({
      ...prev,
      sectorErr: value.trim() ? "" : prev.sectorErr,
    }));
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <div
          className="custom-alert-pop common_alert_popup"
          style={{ display: "block" }}
        >
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{popupMessage}</p>
                <div className="alert-buttons">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      if (isSuccessPopup) {
                        window.location.href = "/promooffers?tab=sector";
                      } else {
                        setAlertPopup(false);
                      }
                    }}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">
              {canEdit
                ? t("edit_sector_promo_offer_txt")
                : t("view_sector_promo_offer_txt")}
            </h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form
                  method="post"
                  className="addform editform promo-form"
                  onSubmit={submitButton}
                >
                  <div className="input-field col-1">
                    <label>{t("cus_sector_txt")}</label>
                    <select
                      value={alertSector}
                      onChange={eventSectorHandleChange}
                      disabled={isReadOnly}
                    >
                      <option value="">{t("select_sector_txt")}</option>
                      {sectorOptions.map((option) => (
                        <option key={option.value} value={option.name}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                    {errormsg.sectorErr && (
                      <div className="error-msg">{errormsg.sectorErr}</div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label>{t("target_cart_value_txt")}</label>
                    <input
                      type="text"
                      value={cartAmountTarget}
                      onChange={targetAmountHandleChange}
                      name="cartAmountTarget"
                      className="form-control"
                      placeholder={t("cart_target_amt_txt")}
                      readOnly={isReadOnly}
                    />
                    {errormsg.cartAmountTargetErr && (
                      <div className="error-msg">
                        {errormsg.cartAmountTargetErr}
                      </div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("flex_title_txt")}</span>
                    <input
                      name="flexTitle"
                      className="form-control"
                      type="text"
                      value={flexTitle}
                      placeholder={t("enter_flex_title_txt")}
                      onChange={handleInputChange(setFlexTitle, "flexTitleErr")}
                      readOnly={isReadOnly}
                    />
                    {errormsg.flexTitleErr && (
                      <div className="error-msg">{errormsg.flexTitleErr}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("target_before_notification_txt")}
                    </span>
                    <textarea
                      name="alertMessage"
                      className="form-control"
                      value={alertMessage}
                      onChange={messageHandleChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.messageErr && (
                      <div className="error-msg">{errormsg.messageErr}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("tooltip_before_reach_cart_target_txt")}
                    </span>
                    <textarea
                      name="beforeTooltipMessage"
                      className="form-control"
                      value={beforeTooltipMessage}
                      onChange={handleInputChange(
                        setBeforeTooltipMessage,
                        "beforeTooltipMessageErr",
                      )}
                      readOnly={isReadOnly}
                    />
                    {errormsg.beforeTooltipMessageErr && (
                      <div className="error-msg">
                        {errormsg.beforeTooltipMessageErr}
                      </div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("target_after_notification_txt")}
                    </span>
                    <textarea
                      name="alertMessage1"
                      className="form-control"
                      value={alertMessage1}
                      onChange={message1HandleChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.message1Err && (
                      <div className="error-msg">{errormsg.message1Err}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("tooltip_after_reach_cart_cart_target_txt")}
                    </span>
                    <textarea
                      name="afterTooltipMessage"
                      className="form-control"
                      value={afterTooltipMessage}
                      onChange={handleInputChange(
                        setAfterTooltipMessage,
                        "afterTooltipMessageErr",
                      )}
                      readOnly={isReadOnly}
                    />
                    {errormsg.afterTooltipMessageErr && (
                      <div className="error-msg">
                        {errormsg.afterTooltipMessageErr}
                      </div>
                    )}
                  </div>
                  {!loading && (
                    <div className="accordion-box input-field">
                      <div
                        onClick={handleclick}
                        className={
                          expanded === true
                            ? "accordion-header show"
                            : "accordion-header"
                        }
                      >
                        <h2>{t("free_product_txt")}</h2>
                        <span className="show-accordion"></span>
                      </div>
                      <div
                        className="accordion-body"
                        style={{
                          display: expanded === true ? "block" : "none",
                        }}
                      >
                        {!freeloading && (
                          <div className="custom_check-box">
                            <div className="edit-free-cat-disp">
                              <h4>
                                {t("select_free_product_txt")}
                              </h4>
                              <div className="edit-free-cat-chks">
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat01"
                                    name="pizza"
                                    onChange={handleFreeCategoryChange}
                                  />
                                  <label htmlFor="fcat01">{t("pizza_txt")}</label>
                                </div>
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat02"
                                    name="pasta"
                                    onChange={handleFreeCategoryChange}
                                    readOnly={isReadOnly}
                                  />
                                  <label htmlFor="fcat02">
                                    {t("pasta_txt")}
                                  </label>
                                </div>
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat04"
                                    name="desserts"
                                    onChange={handleFreeCategoryChange}
                                  />
                                  <label htmlFor="fcat04">{t("desserts_txt")}</label>
                                </div>
                              </div>
                              {isReadOnly ? (
                                // User cannot edit only show checked & active products
                                selectedFreeCategories.length > 0 ? (
                                  filteredFreeProducts.filter(
                                    (prd) =>
                                      checkedfreeval.includes(
                                        prd.productNumber,
                                      ) && prd.PDP_Status !== "deactivate",
                                  ).length > 0 ? (
                                    filteredFreeProducts
                                      .filter(
                                        (prd) =>
                                          checkedfreeval.includes(
                                            prd.productNumber,
                                          ) && prd.PDP_Status !== "deactivate",
                                      )
                                      .map((prd, index) => (
                                        <div
                                          className="check-box"
                                          key={prd.productNumber}
                                        >
                                          <input
                                            type="checkbox"
                                            id={`freechkbox${index}`}
                                            name="freeprd_chkbox"
                                            value={prd.productNumber}
                                            checked={checkedfreeval.includes(
                                              prd.productNumber,
                                            )}
                                            readOnly
                                          />
                                          <label htmlFor={`freechkbox${index}`}>
                                            {prd.productDescription} (
                                            {prd.productNumber})
                                          </label>
                                        </div>
                                      ))
                                  ) : (
                                    <div className="input-field">
                                      <div className="note">
                                        <strong>
                                          {t("no_free_products_avail_now_txt")}
                                        </strong>
                                      </div>
                                    </div>
                                  )
                                ) : null
                              ) : (
                                // User can edit show all products (old flow)
                                filteredFreeProducts.map((prd, index) => {
                                  const isDeactivated =
                                    prd.PDP_Status === "deactivate";
                                  return (
                                    <div
                                      className="check-box"
                                      key={prd.productNumber}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`freechkbox${index}`}
                                        name="freeprd_chkbox"
                                        value={prd.productNumber}
                                        checked={
                                          !isDeactivated &&
                                          checkedfreeval.includes(
                                            prd.productNumber,
                                          )
                                        }
                                        onChange={(e) =>
                                          handleOnChange1(index, e)
                                        }
                                        disabled={isDeactivated}
                                      />
                                      <label htmlFor={`freechkbox${index}`}>
                                        {prd.productDescription} (
                                        {prd.productNumber})
                                      </label>
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {errormsg.checkedfreevalErr && (
                        <div className="error-msg">
                          {errormsg.checkedfreevalErr}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <div className="input-field">
                    <label>{t("free_products_count")}</label>
                    <input
                      type="text"
                      value={freeProductsCount}
                      name="freeProductsCount"
                      onChange={freeCountChange}
                      className="form-control"
                      placeholder={t("free_products_count")}
                      readOnly={isReadOnly}
                    />
                    <div style={{ color: "red" }}>
                      {errmessage.freeProductsCountErr}
                    </div>
                  </div>
                  <div className="input-field">
                    <label>{t("priceband_exclude_txt")}</label>
                    <br /> <br />
                    {priceBandIds.map((priceBand, index) => (
                      <div
                        className="check-box"
                        style={{ display: "inline-block", width: "200px" }}
                      >
                        <input
                          type="checkbox"
                          name="PriceBandTobeExcluded"
                          id={`PriceBandTobeExcluded${index}`}
                          value={priceBand.accountPriceListId}
                          onChange={(e) => {
                            if (isReadOnly) {
                              e.preventDefault();
                              return;
                            }
                            handleOnChangeBand(index, e);
                          }}
                          checked={checkedBandState[index]}
                        />
                        <label htmlFor={`PriceBandTobeExcluded${index}`}>
                          {priceBand.accountPriceListId}{" "}
                        </label>
                      </div>
                    ))}
                  </div>
                  <br /> <br />
                  {/* Status Dropdown */}
                  <div className="input-field col-1">
                    <label className="full-width">{t("status_txt")}</label>
                    <select
                      className="col-4"
                      value={status}
                      onChange={(e) => {
                        if (isReadOnly) return;
                        setStatus(e.target.value);
                      }}
                      disabled={isReadOnly}
                    >
                      <option value="active">{t("active_txt")}</option>
                      <option value="inactive">{t("inactive_txt")}</option>
                    </select>
                  </div>
                  {!isReadOnly && <button title={t("update_txt")} type="submit">{t("update_txt")}</button>}{" "}
                  &nbsp;&nbsp;
                  <button title={t("cancel_txt")} onClick={(e) => cancelbtn(e)}>{t("cancel_txt")}</button>
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};
export default EditSectorPromoOffers;
